export const breakpoints = {
  // Using those breakpoints for avoid breaking changes, Consistency, better Maintainability, Industry Standard and Unnecessary complexity
  base: '0px',
  sm: '20rem', // 320px
  md: '48rem', // 768px
  lg: '60rem', // 960px
  xl: '75rem', // 1200px
  '2xl': '96rem', // 1536px
};
